import React, { useState } from 'react'
import { TextField as MuiTextField } from '@material-ui/core'
import Cancel from '@material-ui/icons/Cancel'
import CheckCircle from '@material-ui/icons/CheckCircle'
import { TextFieldPropsCustom } from './TextFieldType'
import { InputAdornment, IconButton } from '../index'
import theme from '../theme'
import { ThemeProvider } from '@material-ui/core'
import { customClasses, successStylesComponent } from './style'

const TextField: React.FC<TextFieldPropsCustom> = ({ ...props }) => {
  const isRounded = props.variant === 'rounded'
  const borderRadius = isRounded
    ? theme.shape.borderRadiusRounded
    : theme.shape.borderRadius
  const SuccessIcon = successStylesComponent(CheckCircle)
  const [hiddeIcon, setHiddeIcon] = useState(false)
  const success = props.success

  props.success = undefined

  if (isRounded) {
    props.variant = 'outlined'
  }

  if (success) {
    props.error = false
  }

  if (props.error || success) {
    return (
      <ThemeProvider theme={{ ...theme, shape: { borderRadius } }}>
        <MuiTextField
          {...props}
          FormHelperTextProps={{
            className: customClasses().helperText,
          }}
          InputProps={
            hiddeIcon && {
              endAdornment:
                success || props.error ? (
                  <InputAdornment position="end">
                    <IconButton aria-label="Icon" onClick={props.onClickIcon}>
                      {props.error && <Cancel color="error" />}
                      {success && <SuccessIcon />}
                    </IconButton>
                  </InputAdornment>
                ) : undefined,
            }
          }
        />
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider theme={{ ...theme, shape: { borderRadius } }}>
      <MuiTextField
        {...props}
        FormHelperTextProps={{
          className: customClasses().helperText,
        }}
      />
    </ThemeProvider>
  )
}

export default TextField
